// frontend/src/components/AdminNav.jsx
import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function AdminNav() {
  const location = useLocation();

  const links = [
    { path: "/legacy-token-gen", label: "Générateur Aléatoire Classique" },
    { path: "/token-generator-dashboard", label: "Générateur Token Dashboard" },
    { path: "/icosahedron", label: "Icosaèdre Dynamique" },
    { path: "/cubes", label: "Cubes Dynamiques" },
    { path: "/spiral-simple", label: "Spiral Dynamique" },
    { path: "/spiral-torus", label: "Spiral Toroïdale" },
    { path: "/crypto-token-river", label: "Flux de Tokens" },
    { path: "/torus-spring", label: "Tore-Ressorts" },
    { path: "/centrifuge-laser", label: "Centrifugeuse Laser" },
    { path: "/centrifuge-laser-v2", label: "Centrifugeuse Laser 2.0" },
    { path: "/crypto-token-river", label: "CryptoTokenRiver" }, // Doublon maintenu selon demande
    { path: "/metacube-oracle", label: "MetaCube Oracle V1" },
    { path: "/metacube-oracle-v2", label: "MetaCube Oracle V2" },
    { path: "/metacube-oracle-v3", label: "MetaCube Oracle V3" },
    { path: "/metacube-oracle-v4", label: "MetaCube Oracle V4" },
    { path: "/metacube-oracle-v5", label: "MetaCube Oracle V5" },
    { path: "/metacube-quantique", label: "MetaCube Quantique" },
    { path: "/admin", label: "⚡ Interface Admin" },
    { path: "/web3-wallet", label: "👜 Web3 Wallet" },
    { path: "/entropy-dashboard", label: "⚡ Entropy Dashboard" },
    { path: "/governance", label: "🏛️ Reality Verifier" },
    { path: "/retention-policy", label: "🔒 Conservation des Données" }
  ];

  return (
    <div style={{
      background: "#000",
      borderBottom: "1px solid #333",
      padding: "10px",
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "center",
      alignItems: "center",
      gap: "8px",
      width: "100%",
      boxSizing: "border-box"
    }}>
      {links.map((link, idx) => {
        const isActive = location.pathname === link.path;

        return (
          <Link
            key={idx}
            to={link.path}
            style={{
              display: "inline-block",
              // Si actif : CYAN (#00ffcc) + Texte Noir. Sinon : Violet standard + Texte Noir (comme avant)
              background: isActive ? "#00ffcc" : "#a575eb",
              color: "#000",
              padding: "8px 16px",
              borderRadius: "6px",
              textDecoration: "none",
              fontSize: "0.85rem",
              fontWeight: "bold",
              boxShadow: isActive ? "0 0 10px #00ffcc" : "0 2px 5px rgba(165, 117, 235, 0.4)",
              transition: "transform 0.2s, background 0.2s, box-shadow 0.2s",
              textAlign: "center"
            }}
            onMouseOver={(e) => {
              if (!isActive) {
                e.target.style.background = "#b585fb";
                e.target.style.transform = "scale(1.05)";
              }
            }}
            onMouseOut={(e) => {
              if (!isActive) {
                e.target.style.background = "#a575eb";
                e.target.style.transform = "scale(1)";
              }
            }}
          >
            {link.label}
          </Link>
        );
      })}
    </div>
  );
}
